import React, { useEffect } from 'react';
import './index.less'

const Home = () => {
  let timer: string | number | NodeJS.Timeout | undefined

  useEffect(() => {
    const params = new URL(window.location.href)
    const toUrl = params.searchParams.get('to')

    if (toUrl) {
      window.location.href = decodeURIComponent(toUrl)
    } else {
      window.location.href = 'uni://unicc.com/main'
    }
    
    timer = setTimeout(() => {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.unicc.uni'
    }, 3500)

    watchVisibility()
  }, [])

  const watchVisibility = () => {
    window.addEventListener('visibilitychange', () => {
      if(document.hidden) {
        clearTimeout(timer)
      }
    })
  }

  return <div className="home">
    <div className='header'>
      <div className='logo'></div>
    </div>

    <div className="content">
      <div className='slogan'></div>
      <div className='cartoon'></div>
    </div>
    
    <div className='footer'></div>
  </div>
}

export default Home